import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/Dashboard.css';
import chipLogo from '../assets/chip_logo_transparent.png';

const Layout = ({ children, onLogout }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const getActivePage = () => {
    const path = location.pathname;
    if (path === '/' || path === '/dashboard') return 'dashboard';
    if (path.startsWith('/users')) return 'users';
    if (path.startsWith('/finances')) return 'finances';
    if (path.startsWith('/ledger')) return 'ledger';
    if (path.startsWith('/loans')) return 'loans';
    if (path.startsWith('/subscription')) return 'subscription';
    return '';
  };

  const activePage = getActivePage();
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleNavClick = (path) => {
    navigate(path);
    setIsSidebarOpen(false);
  };

  return (
    <div className={`dashboard-container ${isSidebarOpen ? 'sidebar-open' : ''}`}>
      {/* Mobile Overlay */}
      {isSidebarOpen && <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)}></div>}
      
      {/* Sidebar */}
      <aside className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo-container" onClick={() => handleNavClick('/')}>
            <img src={chipLogo} alt="Chip Logo" className="sidebar-logo" />
            <div className="logo-text">Admin</div>
          </div>
          <button className="btn-close-sidebar mobile-only" onClick={() => setIsSidebarOpen(false)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>


        <nav className="nav-list">
          <div className={`nav-item ${activePage === 'dashboard' ? 'active' : ''}`}>
            <div className="nav-link" onClick={() => handleNavClick('/')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
              <span>Dashboard</span>
            </div>
          </div>

          <div className={`nav-item ${activePage === 'ledger' ? 'active' : ''}`}>
            <div className="nav-link" onClick={() => handleNavClick('/ledger')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
              <span>Round-Up</span>
            </div>
          </div>

          <div className={`nav-item ${activePage === 'loans' ? 'active' : ''}`}>
            <div className="nav-link" onClick={() => handleNavClick('/loans')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
              <span>Loans</span>
            </div>
          </div>

          <div className={`nav-item ${activePage === 'subscription' ? 'active' : ''}`}>
            <div className="nav-link" onClick={() => handleNavClick('/subscription')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              <span>Subscription</span>
            </div>
          </div>

          <div className={`nav-item ${activePage === 'users' ? 'active' : ''}`}>
            <div className="nav-link" onClick={() => handleNavClick('/users')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <span>Users</span>
            </div>
          </div>
        </nav>

        <div className="sidebar-footer">
          <button className="btn-logout" onClick={onLogout}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/></svg>
            <span>Logout</span>
          </button>
        </div>
      </aside>

      <main className="main-content">
        <header className="header">
          <div className="header-left-group">
            <button className="hamburger-menu mobile-only" onClick={toggleSidebar}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            </button>
            <h1 className="header-title">
              {activePage === 'dashboard' ? 'Dashboard' : activePage === 'users' ? 'Users' : activePage === 'ledger' ? 'Round-Up' : activePage === 'loans' ? 'Loans' : activePage === 'subscription' ? 'Subscription' : 'Finances'}
            </h1>
          </div>
        </header>

        {children}
      </main>

    </div>
  );
};

export default Layout;

